module.exports = __webpack_public_path__ + "static/media/book-launch.493d3dfa.webp";